export const setWeischerCookie = () => {
    const mainDomain = pmkinoFrontVars && pmkinoFrontVars.cinemaData.main_domain
    const siteDomain = pmkinoFrontVars && pmkinoFrontVars.cinemaData.site.url_site

    if(siteDomain && mainDomain) {
        document.cookie = "last_visited=" + siteDomain + "; domain=" + mainDomain 
    }
}